'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LeadText = undefined;

var _themeProvider = require('@spp/theme-provider');

var _LeadText = require('./LeadText');

var _LeadText2 = _interopRequireDefault(_LeadText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.LeadText = _LeadText2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-lead-text')(_LeadText2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-lead-text/lib/cjs/index.js
 ** module id = 272
 ** module chunks = 1
 **/